@import "../../..//conversational-search-messages/predefined/new-conversation-followup/new-conversation-followup.scss";
@import "../../../../../../styles/variables";

.conversational-search-messages-new-conversation {
  color: $svs-anthracite-grey;
  font-size: 16px;
  margin-top: 11%;

  @media (max-width: $uiaas-tablet) {
    margin-top: 0;
  }

  &__header {
    align-items: center;
    display: flex;
    flex-direction: column;

    strong {
      font-size: 30px;
      line-height: 40px;
      margin-left: 16px;
    }

    div {
      margin-bottom: 10px;
    }
  }

  &__outro-message {
    @media (max-width: $uiaas-tablet) {
      margin-top: 0;
    }

    span:first-of-type {
      display: block;
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 16px;
    }

    span:nth-of-type(2) {
      line-height: 22px;
    }
  }
}
